module.exports = __webpack_public_path__ + "static/media/googleMapIframe範例.mp4";